<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'قوالب الاشعارات'" :to="{name: 'notificationTemplates'}">قوالب الاشعارات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'notificationTemplates.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                             <i class="flaticon-computer-4"></i> 
                                            بيانات قوالب الاشعارات</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                    <div class="row">
                                        <div class="col-md-6">
                                          <label for="exampleFormControlInput12">العنوان</label>
                                          <div class="input-group mb-4">
                                              
                                              <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                              </div>
                                              
                                                <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.title" placeholder=" العنوان ">
                                                
                                                <div class="invalid-feedback" :style="getErrors['title'] ? 'display: block' : 'display: none;'"   v-if="getErrors['title']">
                                                      {{ getErrors['title'][0] }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                          <label for="exampleFormControlInput12">نص الاشعار</label>
                                          <div class="input-group mb-4">
                                              
                                              <textarea v-model="data.form.content" class="form-control" cols="30" rows="10"></textarea>
                                                <div class="invalid-feedback" :style="getErrors['content'] ? 'display: block' : 'display: none;'"   v-if="getErrors['content']">
                                                      {{ getErrors['content'][0] }}
                                                </div>
                                            </div>
                                             <p>* {{data.studentPattern}}</p>
                                             <p>* {{data.datePattern}}</p>
                                             <p>* {{data.attendPattern}}</p>
                                        </div>

                                      </div>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'notificationTemplates'}">
                                      <span>رجوع</span>
                                    </router-link>
                                                          
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        studentPattern: 'لوضع اسم الطالب من فضلك استخدم نمط {{student}}',
        datePattern: 'لوضع تاريخ الغياب من فضلك استخدم نمط {{date}}',
        attendPattern: 'لوضع نوع التحضير من فضلك استخدم نمط {{attend}}',
        checker: false,
        form:{
          title: '',
          content: '',
          status: 1
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      resetForm(){
        this.data.form = {
          title: '',
          content: ''
        };
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/notificationTemplates', this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/notificationTemplates');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        // this.getRoles();
      },
      getRoles(){
        this.$baseApi.get('/notificationTemplates/create').then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data.roles;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
